import { ROOT_HOST } from "~/shared/util/viewManager"

const DEV_ENV_ROOT_HOST_REGEX = /^oneschema.me(:\d+)?$/

const STAGING_ROOT_HOST = "devschema.co"

const OS_PROD_US_ROOT_HOST = "oneschema.co"
const OS_PROD_ROOT_HOST_SUFFIX = ".oneschema.co"

export function getInstanceIdPrefix(): string {
  return ROOT_HOST === OS_PROD_US_ROOT_HOST ? "" : ROOT_HOST
}

export function isOneSchemaProdUsInstance(): boolean {
  return ROOT_HOST === OS_PROD_US_ROOT_HOST
}

export function isOneSchemaProdInstance(): boolean {
  return isOneSchemaProdUsInstance() || ROOT_HOST.endsWith(OS_PROD_ROOT_HOST_SUFFIX)
}

export function isOneSchemaStagingInstance(): boolean {
  return ROOT_HOST === STAGING_ROOT_HOST
}

export function isOneSchemaLocalInstance(): boolean {
  return ROOT_HOST.match(DEV_ENV_ROOT_HOST_REGEX) !== null
}

export function isOneSchemaInstance(): boolean {
  return (
    isOneSchemaProdInstance() ||
    isOneSchemaStagingInstance() ||
    isOneSchemaLocalInstance()
  )
}

export function isSelfHostingInstance(): boolean {
  return !isOneSchemaInstance()
}
